import React from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { PaziaButton, PaziaSwitch } from "components/atoms";
import { settingsApi } from "api";
import { useInvalidateSettings } from "api/hooks/useInvalidateSettings";
import { getApiErrorMessage, useToaster } from "utils";

export interface InvoiceModeSettingsFormProps {
  useKsefInvoices: boolean;
}

export const InvoiceModeSettingsForm = ({ useKsefInvoices }: InvoiceModeSettingsFormProps) => {
  const { showError, showSuccess } = useToaster();
  const invalidateSettings = useInvalidateSettings();
  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: { useKsefInvoices },
  });

  const onSubmit = async (values: InvoiceModeSettingsValues) => {
    try {
      await settingsApi.saveInvoiceMode(values);
      await invalidateSettings();
      methods.reset(values);
      showSuccess("Zapisano tryb wystawiania faktur");
    } catch (error) {
      showError(getApiErrorMessage(error, "Błąd podczas zapisywania trybu wystawiania faktur"));
    }
  };

  const {
    handleSubmit,
    formState: { isDirty },
  } = methods;

  return (
    <FormProvider {...methods}>
      <form className="flex flex-col gap-2" onSubmit={handleSubmit(onSubmit)}>
        <h3 className="font-semibold">Tryb wystawiania faktur</h3>
        <div className="flex flex-wrap items-center gap-4">
          <PaziaSwitch name="useKsefInvoices" label="Faktury wystawiane w KSeF" />
          <PaziaButton type="success" disabled={!isDirty} title="Zapisz" />
        </div>
        <p className="text-sm text-slate-500 dark:text-slate-400">
          Gdy włączone, faktury są wysyłane wyłącznie przez KSeF (PDF nie jest generowany).
        </p>
      </form>
    </FormProvider>
  );
};

const schema = yup
  .object({
    useKsefInvoices: yup.boolean().required(),
  })
  .required();

export type InvoiceModeSettingsValues = yup.InferType<typeof schema>;
